import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ApplyButtonProps {
  text: string;
  onNavigate?: (sectionId: string) => void;
}
export function ApplyButton({
  text,
  onNavigate
}: ApplyButtonProps) {
  const handleClick = () => {
    if (onNavigate) {
      onNavigate('questionnaire');
    } else {
      document.getElementById('questionnaire')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={handleClick} className="bg-gradient-to-r from-cyan-500 via-fuchsia-500 to-cyan-500 text-white font-bold py-5 px-12 rounded-xl hover:shadow-2xl hover:shadow-fuchsia-500/50 transition-all duration-300 inline-flex items-center gap-3 text-lg relative overflow-hidden group" data-id="element-13">
      <div className="absolute inset-0 bg-gradient-to-r from-fuchsia-600 via-cyan-600 to-fuchsia-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-14"></div>
      <span className="relative" data-id="element-15">{text}</span>
      <ArrowRightIcon className="w-5 h-5 relative group-hover:translate-x-1 transition-transform duration-300" data-id="element-16" />
    </button>;
}